import type { SVGProps } from 'react';
const SvgSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.143 5.143c.393 0 .714.321.714.714v14.286a.716.716 0 0 1-.714.714H5.857a.716.716 0 0 1-.714-.714V5.857c0-.393.321-.714.714-.714zM5.857 3A2.86 2.86 0 0 0 3 5.857v14.286A2.86 2.86 0 0 0 5.857 23h14.286A2.86 2.86 0 0 0 23 20.143V5.857A2.86 2.86 0 0 0 20.143 3z"
    />
  </svg>
);
export default SvgSquare;
